import { ThemeProvider, createTheme, type Theme } from '@mui/material/styles';
// import LocalizationProvider from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { type ProviderProps } from '@react-awesome-query-builder/mui';

export default function MaterialProvider(props: ProviderProps & { mainTheme: Theme }) {
	// const settingsTheme = props.config.settings.theme || {};
	// const settingsLocale = props.config.settings.locale || {};
	// const themeConfig = settingsTheme.material;
	// const locale = settingsLocale.material;
	// const useTheme = themeConfig || locale;
	// const theme = useTheme ? createTheme(themeConfig, locale) : null;

	// const base = <div className="mui">{children}</div>;
	// const withProviders = <LocalizationProvider dateAdapter={AdapterMoment}>{base}</LocalizationProvider>;
	// const withTheme = theme ? <ThemeProvider theme={props.mainTheme}>{withProviders}</ThemeProvider> : withProviders;

	return <ThemeProvider theme={props.mainTheme}>{props.children}</ThemeProvider>;
}
